export default {
  inject: ['rocketOn', 'rocketEmit'],

  mounted() {
    if (this.asyncLoad) {
      this.onEvent('init-form', this.initForm);
    }
    this.listenEvent();
  },
  
  methods: {
    onEvent(event, cb) {
      if (this.rocketOn) {
        this.rocketOn(`rocket:remote:common/customize-form:${event}`, true, (e) => {
          cb && cb(e);
        });
      }
    },

    emitEvent(event, ...params) {
      if (this.rocketEmit) {
        this.rocketEmit(`rocket:remote:common/customize-form:${event}`, true, ...params);
      }
    },

    listenEvent() {
      this.onEvent('reset-form', this.resetForm);
      this.onEvent('set-form-values', this.setValues);
      this.onEvent('validate-form', this.validateForm);
    },

    emitValidateFail(values, messages) {
      const schemaMap = {};
      this.schema.forEach((item) => {
        schemaMap[item.key] = item;
      });

      const errList = Object.values(messages).map((item = []) => {
        const itemData = item[0];
        const schemaItem = schemaMap[itemData.field];
        return {
          ...itemData,
          label: schemaItem && schemaItem.label,
        };
      });

      this.emitEvent('validate-fail', values, errList);
    },

    emitValidateSuccess(values) {
      this.emitEvent('validate-success', values);
    },

    emitSaveSuccess(values, info) {
      this.emitEvent('save-success', values, info);
    },

    emitSaveFail(error) {
      this.emitEvent('save-fail', error);
    },

    emitHasSubmittedStatus(status) {
      this.emitEvent('has-submitted', status);
    },

    emitAfterInit(status) {
      this.emitEvent('after-init', status);
    },
  },
};
